import EventIcon from '@mui/icons-material/Event';
import React from 'react';

import { TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { Box } from '_lib/components/Box/Box';
import { Button } from '_lib/components/Button/Button';
import { Card } from '_lib/components/Card/Card';
import { DateTimePicker } from '_lib/components/Pickers/DateTimePicker/DateTimePicker';
import { Stack } from '_lib/components/Stack/Stack';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

export interface RequestedAppointmentProps {
  onDateSelectChange: (newDate: Date | null) => void;
  onOpenAppointmentWindows: () => void;
  appointmentDateTime?: string | null;
  appointmentDateTimeFieldIssueProps: FieldIssueProps;
  required: boolean;
  timezone: TimezoneAbbreviationEnum;
}

export function RequestedAppointment(props: RequestedAppointmentProps) {
  const {
    onDateSelectChange,
    onOpenAppointmentWindows,
    appointmentDateTime,
    appointmentDateTimeFieldIssueProps,
    required,
    timezone
  } = props;

  return (
    <Box>
      <Card variant='outlined'>
        <Stack sx={{ margin: 0.75 }}>
          <Box>
            <DateTimePicker
              clearable
              disablePast
              label='Requested Appointment Date'
              skipDisabled
              textFieldProps={{
                error: appointmentDateTimeFieldIssueProps,
                required
              }}
              timeSteps={{ minutes: 30 }}
              timezone={timezone}
              value={appointmentDateTime ? appointmentDateTime : null}
              onChange={onDateSelectChange}
            />
          </Box>
          <Box>
            <Button
              variant='contained'
              color='primary'
              fullWidth
              onClick={() => onOpenAppointmentWindows()}
              startIcon={<EventIcon />}>
              Appointment Window
            </Button>
          </Box>
        </Stack>
      </Card>
    </Box>
  );
}
